import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DriverFareCalculation } from '@uzurv/clara';
import * as _moment from 'moment-timezone';
const moment = _moment;

export interface DriverFareCalculationHistoryDailogData {
  driverFareCalculations: Array<DriverFareCalculation>;
}

@Component({
  selector: 'app-driver-fare-calculation-history-dialog',
  templateUrl: './driver-fare-calculation-history-dialog.component.html',
  styleUrls: ['./driver-fare-calculation-history-dialog.component.scss']
})
export class DriverFareCalculationHistoryDailogComponent {
  estimate: DriverFareCalculation;

  constructor(
    private dialogRef: MatDialogRef<DriverFareCalculationHistoryDailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DriverFareCalculationHistoryDailogData
  ) {
    this.data.driverFareCalculations.forEach(driverFareCalculations => {
      if (driverFareCalculations.estimate && driverFareCalculations.active) {
        this.estimate = driverFareCalculations;
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  getLabelText(driverFareCalculation: DriverFareCalculation): string {
    if (!(driverFareCalculation.reviewedByUser || driverFareCalculation.adjustedByUser)) {
      return `Original - `;
    }

    if (driverFareCalculation.adjustedByUser && !driverFareCalculation.reviewedByUser) {
      return `Adjusted by: ${driverFareCalculation.adjustedByUser} - `;
    }

    if (driverFareCalculation.reviewedByUser && !driverFareCalculation.adjustedByUser) {
      return `Approved by: ${driverFareCalculation.reviewedByUser} - `;
    }

    if (driverFareCalculation.reviewedByUser && driverFareCalculation.adjustedByUser) {
      return `Approved with adjustments by: ${driverFareCalculation.reviewedByUser} - `;
    }

    return '';
  }

  getDate(driverFareCalculation: DriverFareCalculation): string {
    if (!(driverFareCalculation.reviewedByUser || driverFareCalculation.adjustedByUser)) {
      return driverFareCalculation.createdDate ? moment(driverFareCalculation.createdDate).format('MMM D, YYYY, h:mm:ss A') : '';
    } else {
      return driverFareCalculation.reviewedAt ? moment(driverFareCalculation.reviewedAt).format('MMM D, YYYY, h:mm:ss A') : '';
    }
  }
}
